module.exports = __webpack_public_path__ + "static/img/1.b4cd3b58.jpg";